(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;

  const rails = [...document.querySelectorAll("[data-scroll-rail-inline]")];
  if (!rails.length) return;

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  let raf = null;

  const update = () => {
    raf = null;
    const vh = window.innerHeight || document.documentElement.clientHeight;

    rails.forEach((section) => {
      const track = section.querySelector(".sir-inline__track");
      if (!track) return;

      // Largeur overflow à parcourir
      const viewport = section.querySelector(".sir-inline__viewport");
      if (!viewport) return;

      const overflow = track.scrollWidth - viewport.clientWidth;
      if (overflow <= 0) return;

      const rect = section.getBoundingClientRect();

      // Progression 0..1 pendant que la section traverse le viewport
      // 0 = quand le haut de section arrive en bas de l’écran
      // 1 = quand le bas de section sort par le haut
      const start = vh;                 // rect.top == vh => commence
      const end = -rect.height;         // rect.top == -rect.height => fini
      const progress = clamp((start - rect.top) / (start - end), 0, 1);

      // Droite -> gauche : on va de 0 à -overflow
      const x = -overflow * progress;

      track.style.transform = `translate3d(${x}px, 0, 0)`;
    });
  };

  const onScroll = () => {
    if (raf) return;
    raf = requestAnimationFrame(update);
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  update();
})();
